import axios from "axios";
import environment from './environments/index';


const instance = axios.create({
  baseURL: environment.api.dashboard,
});


export default instance;
